export default "__VITE_ASSET__215d89d1__"